<template>
  <div class="news-container">
    <!-- 列表视图 -->
    <div v-if="!showEditor" class="list-view">
      <Row :gutter="10">
        <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
          <Card>
            <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用"|"作为条件分隔符</Alert>
            <div class="search-con search-con-top">
              <Input class="search-input" v-model="searchVal.key" style="padding:5px;" placeholder="输入关键字全局搜索"
                     @on-enter="searchinput"/>
              <slot name="new_btn">
                <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
              </slot>
              <Button type="error" class="search-btn" @click="handlerDelete">批量删除</Button>
              <el-divider content-position="left">分类筛选</el-divider>
              <el-row :gutter="10" type="flex" style="margin-left: 20px;">
                <el-col :span="8">状态：
                  <el-select
                    v-model="searchVal.state"
                    clearable
                    filterable
                    default-first-option
                    placeholder="请选择状态"
                    style="width: 200px;">
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.meaning"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">类型：
                  <el-select
                    v-model="searchVal.type"
                    clearable
                    filterable
                    default-first-option
                    placeholder="请选择类型"
                    style="width: 200px;">
                    <el-option
                      v-for="item in typeList"
                      :key="item.value"
                      :label="item.meaning"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">模块：
                  <el-select
                    v-model="searchVal.ctype"
                    clearable
                    multiple
                    filterable
                    default-first-option
                    placeholder="请选择模块"
                    style="width: 200px;">
                    <el-option
                      v-for="item in ctypeList"
                      :key="item.value"
                      :label="item.meaning"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row :gutter="10" type="flex" style="margin-left: 20px; margin-top: 10px;">
                <el-col :span="8">
                  <el-button type="primary" icon="el-icon-search" @click="searchinput">搜索</el-button>
                  <el-button type="default" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                </el-col>
              </el-row>
            </div>
            <Spin size="large" fix v-if="spinShow"></Spin>

            <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border
                   :columns="columns" :data="tableData"
                   @on-selection-change="handleSelectChange"></Table>
            <div style="margin: 10px; overflow: hidden">
              <div style="float: left;">
                <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                      show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
                </Page>
              </div>
            </div>
          </Card>
        </i-col>
      </Row>
    </div>

    <!-- 编辑器视图 -->
    <div v-else class="editor-view">
      <div class="editor-header">
        <Button @click="closeEditor" icon="md-arrow-back" class="back-btn">返回</Button>
        <span class="editor-title">{{ modalMap.modalTitle }}</span>
        <Button type="primary" @click="handleSubmit('formValidate')" :loading="submitLoading" class="save-btn">保存</Button>
      </div>

      <div class="editor-container">
        <!-- 左侧手机预览区域 -->
        <div class="mobile-preview-area">
          <div class="mobile-frame">
            <div class="mobile-screen">
              <div class="mobile-status-bar">
                <div class="status-left">
                  <span class="time">{{currentTime()}}</span>
                </div>
                <div class="status-right">
                  <div class="battery"></div>
                  <div class="signal"></div>
                  <div class="wifi"></div>
                </div>
              </div>
              <div class="mobile-content">
                <div class="mobile-header">
                  <div class="mobile-back-btn">‹</div>
                  <div class="mobile-page-title">{{ formValidate.title || '文章标题' }}</div>
                  <div class="mobile-more-btn">⋯</div>
                </div>
                <div class="mobile-article-content">
                  <div class="rich-editor-wrapper">
                    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
                      <FormItem prop="content">
                        <TinyMCEEditor
                          ref="myedit"
                          v-model="formValidate.content"
                          :height="500"
                          @on-change="handleContentChange"
                          @on-init="handleEditorInit">
                        </TinyMCEEditor>
                      </FormItem>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧配置区域 -->
        <div class="editor-right">
          <!-- 标题和封面设置 -->
          <div class="params-panel">
            <div class="panel-section">
              <div class="section-title">基本信息</div>
              <Form :model="formValidate" :rules="ruleValidate" :label-width="80">
                <FormItem label="标题" prop="title">
                  <Input
                    v-model="formValidate.title"
                    placeholder="请输入标题"
                    size="large"
                  />
                </FormItem>

                <FormItem label="封面图片">
                  <div class="cover-upload">
                    <div class="demo-upload-list" v-if="formValidate.cover_image">
                      <img :src="formValidate.cover_image">
                      <div class="demo-upload-list-cover">
                        <Icon type="ios-eye-outline" @click="handleView(formValidate.cover_image)" size="40"></Icon>
                        <Icon type="ios-trash-outline" @click="handleRemoveCover" size="40"></Icon>
                      </div>
                    </div>

                    <Upload
                      v-else
                      :show-upload-list="false"
                      :on-success="handleCoverSuccess"
                      :format="['jpg','jpeg','png']"
                      :max-size="5120"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
                      :before-upload="handleBeforeUpload"
                      :data="{nid:formValidate.id}"
                      name="imgdata"
                      type="drag"
                      action="https://zgkd.zzrcfzjt.com/api/v1/upload/upload"
                      :headers="up_headers"
                      class="cover-uploader">
                      <div class="upload-area">
                        <Icon type="ios-camera" size="40"></Icon>
                        <p>点击或拖拽上传封面图片</p>
                      </div>
                    </Upload>
                  </div>
                </FormItem>
              </Form>
            </div>

            <div class="panel-section">
              <div class="section-title">发布设置</div>
              <Form :model="formValidate" :rules="ruleValidate" :label-width="80">
                <FormItem label="类别" prop="type">
                  <el-select
                    v-model="formValidate.type"
                    filterable
                    allow-create
                    default-first-option
                    placeholder="请选择"
                    class="full-width">
                    <el-option
                      v-for="item in typeList"
                      :key="item.value"
                      :label="item.meaning"
                      :value="parseInt(item.value)">
                    </el-option>
                  </el-select>
                </FormItem>

                <FormItem label="模块" prop="ctype">
                  <el-select
                    v-model="formValidate.ctype"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    placeholder="请选择模块"
                    class="full-width">
                    <el-option
                      v-for="item in ctypeList"
                      :key="item.value"
                      :label="item.meaning"
                      :value="parseInt(item.value)">
                    </el-option>
                  </el-select>
                </FormItem>

                <FormItem label="状态" prop="state">
                  <el-select
                    v-model="formValidate.state"
                    filterable
                    allow-create
                    default-first-option
                    placeholder="请选择"
                    class="full-width">
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.meaning"
                      :value="parseInt(item.value)">
                    </el-option>
                  </el-select>
                </FormItem>

                <FormItem label="可进入详情" prop="can_detail">
                  <el-select
                    v-model="formValidate.can_detail"
                    filterable
                    default-first-option
                    placeholder="请选择"
                    class="full-width">
                    <el-option
                      v-for="item in canDetailList"
                      :key="item.value"
                      :label="item.meaning"
                      :value="parseInt(item.value)">
                    </el-option>
                  </el-select>
                </FormItem>
              </Form>
            </div>

            <div class="panel-section">
              <div class="section-title">时间设置</div>
              <Form :model="formValidate" :rules="ruleValidate" :label-width="80">
                <FormItem label="开始时间" prop="s_time">
                  <DatePicker
                    type="datetime"
                    editable
                    v-model="formValidate.s_time"
                    format="yyyy-MM-dd HH:mm:ss"
                    placement="bottom-end"
                    placeholder="请选择开始时间"
                    class="full-width">
                  </DatePicker>
                </FormItem>

                <FormItem label="结束时间" prop="e_time">
                  <DatePicker
                    type="datetime"
                    editable
                    v-model="formValidate.e_time"
                    format="yyyy-MM-dd HH:mm:ss"
                    placement="bottom-end"
                    placeholder="请选择结束时间"
                    class="full-width">
                  </DatePicker>
                </FormItem>
              </Form>
            </div>

            <div class="panel-section">
              <div class="section-title">操作</div>
              <div class="action-buttons">
                <Button type="primary" @click="handleSubmit('formValidate')" :loading="submitLoading" class="action-btn">保存</Button>
                <Button @click="handleReset('formValidate')" class="action-btn">重置</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 图片预览Modal -->
    <Modal title="查看图片" v-model="imageVisible">
      <img :src="previewImage" style="width: 100%">
    </Modal>
  </div>
</template>
<script>

import {
  getNewsinfolist,
  operationNewsinfo
} from '@/api/news/newsinfo.js'
import { getsysparameterList } from '@/api/system/sys_parameter'
import TinyMCEEditor from '@/components/editor/TinyMCEEditor'

let moment = require('moment')
export default {
  components: { TinyMCEEditor },
  data () {
    return {
      showEditor: false, // 控制显示列表还是编辑器
      submitLoading: false, // 提交按钮加载状态
      editor: null,
      stateList: [],
      typeList: [],
      ctypeList: [],
      canDetailList: [
        { value: '0', meaning: '否' },
        { value: '1', meaning: '是' }
      ],
      spinShow: false,
      imageVisible: false,
      previewImage: '',
      fullscreenLoading: false,
      formValidate: {},
      up_headers: {},
      searchVal: {
        key: '',
        state: '',
        type: '',
        ctype: []
      },
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '新建'
      },
      tableSelectIdList: [],
      editModalData: '',
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

      ruleValidate: {
        title: [
          {
            required: true,
            message: '标题不能为空',
            trigger: 'blur'
          }
        ],
        content: [
          {
            required: true,
            message: '内容不能为空',
            trigger: 'blur'
          }
        ],
        s_time: [
          {
            required: true,
            type: 'date',
            message: '请选择开始时间',
            trigger: 'change'
          }
        ],
        e_time: [
          {
            required: true,
            type: 'date',
            message: '请选择结束时间',
            trigger: 'change'
          }
        ],
        ctype: [
          {
            type: 'array',
            required: false,
            message: '请选择模块',
            trigger: 'change'
          }
        ]
        // can_detail: [
        //   {
        //     required: true,
        //     message: '请选择是否可进入详情',
        //     trigger: 'change'
        //   }
        // ]
      },
      columns: [
        {
          type: 'selection',
          key: 'id',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '标题',
          key: 'title',
          width: 250,
          tooltip: 'true',
          align: 'center',
          sortable: true },
        {
          title: '封面图片',
          key: 'cover_image',
          width: 100,
          align: 'center',
          render: (h, params) => {
            if (params.row.cover_image) {
              return h('img', {
                attrs: {
                  src: params.row.cover_image,
                  style: 'width: 50px; height: 50px;'
                },
                on: {
                  click: () => {
                    this.handleView(params.row.cover_image)
                  }
                }
              })
            } else {
              return h('span', '无')
            }
          }
        },
        {
          title: '内容',
          key: 'content',
          width: 100,
        tooltip: true,
          align: 'center',
        render: (h, params) => {
    // 去除 HTML 标签并返回纯文本
    const textContent = this.stripHTML(params.row.content)
      return h('div', textContent.slice(0, 30) + '...') // 直接返回文本字符串的 div VNode
    },
          sortable: true },
        {
          title: '阅读数',
          key: 'reads',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '状态',
          key: 'state_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '类型',
          key: 'type_CN',
          width: 120,
          align: 'center',
          sortable: true },
        {
          title: '模块',
          key: 'ctype_CN',
          width: 120,
          align: 'center',
          sortable: true,
          render: (h, params) => {
            // 处理模块字段的显示，支持多选数组显示
            if (params.row.ctype_CN) {
              if (Array.isArray(params.row.ctype_CN)) {
                // 如果是数组，用标签显示每个选项
                return h('div', params.row.ctype_CN.map(item =>
                  h('Tag', {
                    props: { color: 'blue' },
                    style: { marginRight: '5px', marginBottom: '2px' }
                  }, item)
                ))
              } else if (typeof params.row.ctype_CN === 'string') {
                // 如果是字符串，检查是否是逗号分隔的多个值
                if (params.row.ctype_CN.includes(',')) {
                  const items = params.row.ctype_CN.split(',').map(item => item.trim()).filter(item => item)
                  return h('div', items.map(item =>
                    h('Tag', {
                      props: { color: 'blue' },
                      style: { marginRight: '5px', marginBottom: '2px' }
                    }, item)
                  ))
                } else {
                  // 单个值显示为标签
                  return h('Tag', { props: { color: 'blue' } }, params.row.ctype_CN)
                }
              }
            }
            return h('div', '-')
          }
        },
        {
          title: '可进入详情',
          key: 'can_detail',
          width: 100,
          align: 'center',
          render: (h, params) => {
            const value = params.row.can_detail
            const text = value === 1 ? '是' : '否'
            const color = value === 1 ? 'success' : 'default'
            return h('Tag', { props: { color: color } }, text)
          }
        },
        {
          title: '开始时间',
          key: 's_time',
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '结束时间',
          key: 'e_time',
          width: 180,
          align: 'center',
          sortable: true },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'post', '修改')
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.delData(params)
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
    // 处理编辑器初始化
    handleEditorInit (editor) {
      this.editor = editor
    },
    // 处理编辑器内容变化
    handleContentChange (html, text) {
      // console.log('内容变化:', html)
      this.formValidate.content = html
    },
    onCreated (editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    getParameterList () {
          getsysparameterList('news_info', 'state').then(res => {
            if (res.data.code === 0) {
              this.stateList = res.data.data
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
      getsysparameterList('news_info', 'type').then(res => {
        if (res.data.code === 0) {
          this.typeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('news_info', 'ctype').then(res => {
        if (res.data.code === 0) {
          this.ctypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
        },
    stripHTML (html) {
      // 使用正则表达式匹配并去除 HTML 标签
      const text = html.replace(/<[^>]*>/g, '')
      return text
    },
    handleView (imageUrl) {
      this.previewImage = imageUrl
      this.imageVisible = true
    },
    handleBeforeUpload (config) {
      return new Promise((resolve) => {
    // 生成动态授权头
    const now = new Date()
    const hours = now.getHours().toString().padStart(2, '0')
    const minutes = now.getMinutes().toString().padStart(2, '0')
    const month = (now.getMonth() + 1).toString().padStart(2, '0')
    const day = now.getDate().toString().padStart(2, '0')
    const year = now.getFullYear()

    const rawString = `zgkd_upimage_${hours}${minutes}${month}${day}${year}`
    const base64String = btoa(rawString)

    this.up_headers = {
      'Authorization': base64String
    }

    // 确保 Vue 响应式更新完成
    this.$nextTick(() => {
      this.spinShow = true // 显示加载状态
      resolve(true) // 允许上传
    })
  })
    },
    handleCoverSuccess (res, file) {
      this.spinShow = false
      console.log(res)
      if (res.code === 200) {
        let imgSrc = res.data.path
        file.url = imgSrc
        // file.name = res.data.filename
        this.formValidate.cover_image = imgSrc
      } else {
        this.$Message.error(`${res.msg}`)
      }
    },
    handleRemoveCover () {
      this.formValidate.cover_image = ''
    },
    handleFormatError (file) {
      this.spinShow = false
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '文件 ' + file.name + ' 格式不正确，请上传 jpg 或 png 格式的图片。'
      })
    },
    handleMaxSize (file) {
      this.spinShow = false
      this.$Notice.warning({
        title: '超出文件大小限制',
        desc: '文件 ' + file.name + ' 太大，不能超过 5M。'
      })
    },
    currentTime () {
      return new Date().toLocaleTimeString() // 返回本地时间字符串
    },
    resetSearch () {
      this.searchVal = {
        key: '',
        state: '',
        type: '',
        ctype: []
      }
      this.getNewsinfolist()
    },
    getNewsinfolist (searchParams) {
      this.spinShow = true

      // 构建搜索参数
      let params = {}
      if (searchParams) {
        if (typeof searchParams === 'string') {
          // 兼容旧的字符串搜索
          params.key = searchParams
        } else if (typeof searchParams === 'object') {
          // 新的对象搜索
          if (searchParams.key) {
            params.key = searchParams.key
          }
          if (searchParams.state) {
            params.state = searchParams.state
          }
          if (searchParams.type) {
            params.type = searchParams.type
          }
          if (searchParams.ctype && searchParams.ctype.length > 0) {
            // 将多选的ctype数组转换为逗号分隔的字符串
            params.ctype = searchParams.ctype.join(',')
          }
        }
      }

      getNewsinfolist(this.pageNum, this.pageSize, params.key, params).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count
          // 处理表格数据，确保ctype_CN字段正确显示
          this.tableData = res.data.data.map(item => {
            const processedItem = { ...item }
            // 如果后端没有返回ctype_CN，尝试根据ctype生成
            if (!processedItem.ctype_CN && processedItem.ctype && this.ctypeList.length > 0) {
              processedItem.ctype_CN = this.convertCtypeToDisplay(processedItem.ctype)
            }
            return processedItem
          })
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    // 将ctype数组转换为显示文本
    convertCtypeToDisplay (ctype) {
      if (!ctype || !this.ctypeList.length) return ''

      let ctypeArray = []
      if (Array.isArray(ctype)) {
        ctypeArray = ctype
      } else if (typeof ctype === 'string') {
        try {
          if (ctype.startsWith('[') && ctype.endsWith(']')) {
            ctypeArray = JSON.parse(ctype)
          } else if (ctype.includes(',')) {
            ctypeArray = ctype.split(',').map(item => parseInt(item.trim())).filter(item => !isNaN(item))
          } else {
            const val = parseInt(ctype)
            if (!isNaN(val)) {
              ctypeArray = [val]
            }
          }
        } catch (e) {
          console.warn('解析ctype数据失败:', e)
          return ''
        }
      } else if (typeof ctype === 'number') {
        ctypeArray = [ctype]
      }

      // 根据值找到对应的meaning
      return ctypeArray.map(val => {
        const found = this.ctypeList.find(item => parseInt(item.value) === val)
        return found ? found.meaning : val.toString()
      }).filter(item => item)
    },

    handleSelectChange (val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeEditor () {
      this.showEditor = false
      this.modalMap.modalVisible = false
      this.formValidate = {}
    },
    closeModal () {
      this.dialog.show = false
    },
    editModal (paramsRow, meth, mtitle) {
      this.showEditor = true // 显示编辑器
      this.modalMap.modalVisible = true
      this.modalMap.modalTitle = mtitle
      this.editModalData = meth
      this.getParameterList()
      var day2 = new Date()
      day2.setTime(day2.getTime())
      var s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate() + ' ' + day2.getHours() + ':' + day2.getMinutes() + ':' + day2.getSeconds()
      this.formValidate.s_time = s2
      this.formValidate.e_time = s2
      if (paramsRow && paramsRow.id) {
        // 处理ctype数据格式，确保为数组
        let ctypeArray = []
        if (paramsRow.ctype) {
          if (Array.isArray(paramsRow.ctype)) {
            // 如果已经是数组，直接使用
            ctypeArray = paramsRow.ctype
          } else if (typeof paramsRow.ctype === 'string') {
            // 如果是字符串，尝试解析
            try {
              if (paramsRow.ctype.startsWith('[') && paramsRow.ctype.endsWith(']')) {
                // JSON数组格式
                ctypeArray = JSON.parse(paramsRow.ctype)
              } else if (paramsRow.ctype.includes(',')) {
                // 逗号分隔格式
                ctypeArray = paramsRow.ctype.split(',').map(item => parseInt(item.trim())).filter(item => !isNaN(item))
              } else {
                // 单个值
                const val = parseInt(paramsRow.ctype)
                if (!isNaN(val)) {
                  ctypeArray = [val]
                }
              }
            } catch (e) {
              console.warn('解析ctype数据失败:', e)
              ctypeArray = []
            }
          } else if (typeof paramsRow.ctype === 'number') {
            // 如果是数字，转换为数组
            ctypeArray = [paramsRow.ctype]
          }
        }
        this.formValidate = {
          id: paramsRow.id,
          title: paramsRow.title,
          content: paramsRow.content,
          cover_image: paramsRow.cover_image || '',
          files: paramsRow.files,
          reads: paramsRow.reads,
          state: paramsRow.state,
          type: paramsRow.type,
          ctype: ctypeArray,
          can_detail: paramsRow.can_detail || 0,
          s_time: paramsRow.s_time,
          e_time: paramsRow.e_time
        }

        // this.$refs['myedit'].setnid()
        this.$refs['myedit'].setContent(paramsRow.content)
      } else {
        this.formValidate = {
          id: 0,
          title: '',
          content: '',
          cover_image: '',
          files: '',
          reads: '',
          state: '',
          type: '',
          ctype: [],
          can_detail: 1, // 默认可进入详情
          s_time: s2,
          e_time: s2
        }
        this.$refs['myedit'].setContent('')
      }
    },
    handleSubmit (value) {
      this.submitLoading = true
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.s_time = moment(this.formValidate.s_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            this.formValidate.e_time = moment(this.formValidate.e_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss')
            operationNewsinfo(this.formValidate, this.editModalData).then(res => {
              this.submitLoading = false
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal.key || this.searchVal.state || this.searchVal.type || this.searchVal.ctype.length > 0) {
                  this.getNewsinfolist(this.searchVal)
                } else {
                  this.getNewsinfolist()
                }
                this.closeEditor() // 关闭编辑器
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          console.log(this.formValidate)
          this.submitLoading = false
          this.$Message.error('缺少必要参数')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    handlerDelete () {
      if (this.tableSelectIdList.length > 0) {
        if (confirm(`确定要批量删除选中数据嘛？ `)) {
          operationNewsinfo({ 'id_list': this.tableSelectIdList }, 'delete').then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.getNewsinfolist(this.searchVal)
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
        }
      } else {
        this.$Message.info(`你总要选中点什么吧`)
      }
    },
    delData (params) {
      if (confirm(`确定要删除该信息吗？`)) {
        operationNewsinfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            this.tableData.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    changePage (value) {
      this.pageNum = value
      if (this.searchVal.key || this.searchVal.state || this.searchVal.type || this.searchVal.ctype.length > 0) {
        this.getNewsinfolist(this.searchVal)
      } else {
        this.getNewsinfolist()
      }
    },
    handlePageSize (value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal.key || this.searchVal.state || this.searchVal.type || this.searchVal.ctype.length > 0) {
        this.getNewsinfolist(this.searchVal)
      } else {
        this.getNewsinfolist()
      }
    },
    searchinput () {
      if (this.searchVal.key || this.searchVal.state || this.searchVal.type || this.searchVal.ctype.length > 0) {
        this.getNewsinfolist(this.searchVal)
      } else {
        this.getNewsinfolist()
      }
    }
  },
  watch: {
    searchVal: {
      handler (val) {
        this.searchVal = val
      },
      deep: true
    }
  },
  mounted () {
    // tinymce.init({})
    // 先获取参数列表，再获取数据列表
    this.getParameterList()
    this.getNewsinfolist()
  },
  beforeDestroy () {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>

<style lang="less" scoped>
.news-container {
  height: 100vh;
  overflow: hidden;
}

// 列表视图样式
.list-view {
  .search-con {
    padding: 10px 0;
    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }
      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }
      &-btn {
        margin-left: 2px;
      }
    }
  }
}

// 编辑器视图样式
.editor-view {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
  overflow: hidden;

  .editor-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    background: #fff;
    border-bottom: 1px solid #e8eaec;
    box-shadow: 0 2px 4px rgba(0,0,0,0.06);
    z-index: 100;

    .back-btn {
      border: none;
      background: transparent;
      color: #666;
      font-size: 14px;

      &:hover {
        color: #2d8cf0;
        background: rgba(45, 140, 240, 0.1);
      }
    }

    .editor-title {
      font-size: 18px;
      font-weight: 500;
      color: #333;
    }

    .save-btn {
      background: #2d8cf0;
      border-color: #2d8cf0;
      border-radius: 4px;
      font-weight: 500;
    }
  }

  .editor-container {
    flex: 1;
    display: flex;
    gap: 20px;
    padding: 20px;
    overflow: hidden;
    min-height: 0;

    // 左侧手机预览区域
    .mobile-preview-area {
      flex-shrink: 0;
      width: 395px;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .mobile-frame {
        width: 375px;
        height: 667px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 36px;
        padding: 8px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(255, 255, 255, 0.1);
        position: relative;

        // 添加手机外壳细节
        &::before {
          content: '';
          position: absolute;
          top: 28px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 6px;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 3px;
        }

        // 添加home键
        &::after {
          content: '';
          position: absolute;
          bottom: 12px;
          left: 50%;
          transform: translateX(-50%);
          width: 40px;
          height: 4px;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 2px;
        }

        .mobile-screen {
          width: 100%;
          height: 100%;
          background: #fff;
          border-radius: 28px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          position: relative;

          .mobile-status-bar {
            height: 44px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;
            font-size: 14px;
            font-weight: 600;
            color: #000;
            border-bottom: 1px solid #f0f0f0;

            .status-left {
              .time {
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
              }
            }

            .status-right {
              display: flex;
              align-items: center;
              gap: 6px;

              .battery, .signal, .wifi {
                width: 20px;
                height: 12px;
                background: #000;
                border-radius: 2px;
                opacity: 0.8;
              }

              .battery {
                position: relative;
                &::after {
                  content: '';
                  position: absolute;
                  right: -3px;
                  top: 3px;
                  width: 2px;
                  height: 6px;
                  background: #000;
                  border-radius: 0 1px 1px 0;
                }
              }

              .signal {
                width: 18px;
                height: 12px;
                background: linear-gradient(to right, #000 0%, #000 25%, #ccc 25%, #ccc 50%, #000 50%, #000 75%, #ccc 75%);
              }

              .wifi {
                width: 15px;
                height: 12px;
                background: radial-gradient(circle at bottom, #000 0%, #000 40%, transparent 40%);
                border-radius: 15px 15px 0 0;
              }
            }
          }

          .mobile-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .mobile-header {
              height: 56px;
              background: #fff;
              display: flex;
              align-items: center;
              padding: 0 16px;
              border-bottom: 1px solid #f0f0f0;
              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

              .mobile-back-btn {
                font-size: 24px;
                color: #2d8cf0;
                font-weight: bold;
                cursor: pointer;
                padding: 8px;
                margin-right: 12px;
              }

              .mobile-page-title {
                flex: 1;
                font-size: 18px;
                font-weight: 500;
                color: #333;
                text-align: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 200px;
              }

              .mobile-more-btn {
                font-size: 20px;
                color: #666;
                padding: 8px;
                cursor: pointer;
              }
            }

            .mobile-article-content {
              flex: 1;
              overflow: hidden;
              padding: 16px;
              background: #fff;

              .rich-editor-wrapper {
                height: 100%;

                /deep/ .tinymce-editor-wrapper {
                  height: 100%;
                  border: none;

                  .tox {
                    height: 100%;
                    border: none !important;

                    .tox-toolbar-overlord {
                      background: #f8f9fa;
                      border: none;
                      border-bottom: 1px solid #e9ecef;
                    }

                    .tox-toolbar__primary {
                      background: #f8f9fa;
                      padding: 8px;
                      border-bottom: 1px solid #e9ecef;

                      .tox-toolbar__group {
                        margin: 0 4px;
                      }

                      .tox-tbtn {
                        width: 32px;
                        height: 32px;
                        margin: 2px;
                        border-radius: 4px;

                        &:hover {
                          background-color: #e3f2fd;
                        }

                        &.tox-tbtn--enabled {
                          background-color: #2d8cf0;
                          color: #fff;
                        }
                      }
                    }

                    .tox-edit-area {
                      border: none;
                    }

                    .tox-edit-area__iframe {
                      border: none !important;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    // 右侧配置区域
    .editor-right {
      flex: 1;
      min-width: 400px;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      overflow-y: auto;
      //max-height: calc(100vh - 120px);
      border: 1px solid #e8eaec; // 添加边框确保可见

      .params-panel {
        .panel-section {
          padding: 24px;
          border-bottom: 1px solid #f0f2f5;

          &:last-child {
            border-bottom: none;
          }

          .section-title {
            font-size: 16px;
            font-weight: 600;
            color: #262626;
            margin-bottom: 20px;
            padding-bottom: 8px;
            border-bottom: 2px solid #2d8cf0;
            display: inline-block;
            width: auto;
          }

          .full-width {
            width: 100%;
          }

          .cover-upload {
            .demo-upload-list {
              display: inline-block;
              width: 200px;
              height: 120px;
              text-align: center;
              line-height: 120px;
              border: 1px solid #d9d9d9;
              border-radius: 6px;
              overflow: hidden;
              background: #fafafa;
              position: relative;
              box-shadow: 0 2px 8px rgba(0,0,0,.08);

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

              .demo-upload-list-cover {
                display: none;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background: rgba(0,0,0,.6);

                i {
                  color: #fff;
                  font-size: 20px;
                  cursor: pointer;
                  margin: 0 8px;
                  line-height: 120px;

                  &:hover {
                    color: #2d8cf0;
                  }
                }
              }

              &:hover .demo-upload-list-cover {
                display: block;
              }
            }

            .cover-uploader {
              /deep/ .ivu-upload {
                width: 200px;
                height: 120px;

                .ivu-upload-drag {
                  width: 100%;
                  height: 100%;
                  border: 2px dashed #d9d9d9;
                  border-radius: 6px;
                  background: #fafafa;
                  transition: all 0.3s;

                  &:hover {
                    border-color: #2d8cf0;
                    background: rgba(45, 140, 240, 0.05);
                  }

                  .upload-area {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #666;

                    i {
                      margin-bottom: 8px;
                      color: #999;
                    }

                    p {
                      margin: 0;
                      font-size: 12px;
                      color: #999;
                    }
                  }
                }
              }
            }
          }

          .action-buttons {
            display: flex;
            gap: 12px;

            .action-btn {
              flex: 1;
              height: 40px;
              border-radius: 6px;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

// 表单样式优化
/deep/ .ivu-form-item {
  margin-bottom: 20px;

  .ivu-form-item-label {
    font-weight: 500;
    color: #333;
  }

  .ivu-form-item-content {
    .el-select {
      width: 100%;

      .el-input__inner {
        border-radius: 6px;
        border-color: #d9d9d9;
        height: 36px;

        &:focus {
          border-color: #2d8cf0;
        }
      }
    }

    .ivu-input-wrapper {
      width: 100%;

      .ivu-input {
        border-radius: 6px;
        border-color: #d9d9d9;
        height: 36px;
        padding: 8px 12px;

        &:focus {
          border-color: #2d8cf0;
        }
      }
    }

    .ivu-date-picker {
      width: 100%;

      .ivu-input {
        border-radius: 6px;
        border-color: #d9d9d9;
        height: 36px;

        &:focus {
          border-color: #2d8cf0;
        }
      }
    }
  }
}

// 滚动条样式
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;

  &:hover {
    background: #a8a8a8;
  }
}
</style>
